import { FEDERAL_INSUFFICIENT_PURPOSES } from '../generated/constants.gen';

/*
 * The list is generated from FederalPurposeDescriptions. The folding
 * below is still a hand copy of the C# `Normalize`; keep the two in step.
 *
 * WHERE NOT TO USE THIS: the close-hub ledger's purpose mark reads the preflight VERDICT,
 * never this helper. The verdict knows each payee's election-cycle aggregate; this file
 * cannot. They answer different questions on purpose, so don't "unify" them.
 */

/**
 * Folds a typed purpose to its comparison key — lower-cased, every run of punctuation or
 * whitespace reduced to one separator, ends trimmed — so a padded "Get-Out-The-Vote." and a
 * bare "get out the vote" land on the same key. Mirrors the C# `Normalize`.
 */
function normalizeFederalPurpose(purpose: string): string {
  return purpose.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
}

/**
 * True when `purpose` says nothing — blank, or punctuation with no words in it — or is one
 * of the regulation's named-insufficient descriptions, however the treasurer happened to
 * type it.
 *
 * Matching is whole-string, never substring: the regulation's GOOD examples overlap its bad
 * ones word-for-word ("travel expenses" is sufficient, bare "expenses" is not), so a
 * `includes` test would flag the very purposes the rule rewards.
 */
export function isInsufficientFederalPurpose(purpose: string | null | undefined): boolean {
  if (purpose == null || purpose.trim() === '') return true;
  const key = normalizeFederalPurpose(purpose);
  return key.length === 0 || FEDERAL_INSUFFICIENT_PURPOSES.includes(key);
}
